module.exports = __webpack_public_path__ + "media/images/about-us/PGA/Northern California PGA-5762a9ca465b59d7718566b2dbd82e73.png";